import assign from 'lodash/assign';
import cloneDeep from 'lodash/cloneDeep';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const emptyListings = {
    view: {
        total: { Views: '0', months: [], isEmpty: true },
        average: { Views: '0', months: [], isEmpty: true },
    },
    leadClick: {
        total: {
            Contacts: '0', Clicks: '0', months: [], isEmpty: true,
        },
        average: {
            Contacts: '0', Clicks: '0', months: [], isEmpty: true,
        },
    },
    property: {
        total: { Listings: '0', months: [], isEmpty: true },
        average: { Listings: '0', months: [], isEmpty: true },
    },
};

const emptyReviews = {
    review: {
        total: { Reviews: '0', months: [], isEmpty: true },
        average: { Rating: '0', months: [], isEmpty: true },
    },
};

const emptyInvoices = {
    invoice: {
        total: {
            'Rent Connect': '0', Boost: '0', months: [], isEmpty: true,
        },
        average: {
            'Rent Connect': '0', Boost: '0', months: [], isEmpty: true,
        },
    },
};

const initState = () => cloneDeep({
    ...emptyListings,
    ...emptyReviews,
    ...emptyInvoices,
});

const graphs = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_OVERVIEW_GET_SUCCESS:
            return assign({}, state, payload);
        case DispatchConstants.ANALYTICS_OVERVIEW_LISTINGS_GET_FAIL:
            return assign({}, state, ...emptyListings);
        case DispatchConstants.ANALYTICS_OVERVIEW_REVIEWS_GET_FAIL:
            return assign({}, state, ...emptyReviews);
        case DispatchConstants.ANALYTICS_OVERVIEW_INVOICES_GET_FAIL:
            return assign({}, state, ...emptyInvoices);
        default:
            return state;
    }
};

export default graphs;
